<template>
  <b-modal
    ref="scoutConfirmModal"
    id="scoutConfirmModal"
    modal-class="scout-confirm-modal"
    size="md"
    backdrop="static"
    centered
    hide-header
  >
  <div class="confirmation-content d-flex flex-column align-items-center">
    <p class="text-center" style="font-weight: bold; font-size: 16px;">スカウトを希望しますか？</p>
    <p class="text-center" style="font-weight: bold; font-size: 16px">スカウト希望は<span style="color: #ff0000;">5件</span>まで可能です</p>
    <p class="mt-4 font-12">
      あなたがこの求人でスカウトを希望していることが企業に通知されます（企業からのスカウトを確約するものではありません）<br />
      スカウト希望後の取り下げはできません
    </p>
    <p class="mt-2">

    </p>
  </div>
    <template #modal-footer>
      <div class="d-flex  w-100" style="justify-content: space-around">
        <b-button class="scout-button" @click="$emit('confirm')"
          >スカウトを希望する</b-button
        >
        <b-button class="next-button" @click="$emit('cancel')"
          >キャンセル</b-button
        >
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "ScoutConfirmationModal",
  methods: {
    show() {
      this.$refs.scoutConfirmModal.show();
    },
    hide() {
      this.$refs.scoutConfirmModal.hide();
    },
  },
};
</script>

<style scoped>
.font-12 {
  font-size: 12px;;
}
>>> .scout-confirm-modal .modal-footer {
  background: #ffffff !important;
  border-top: none !important;
}
>>> .scout-confirm-modal .confirmation-content {
  padding: 50px 10px;
}

.text-center {
  text-align: center;
}

/* Mobile responsive styles for button container */
@media (max-width: 768px) {
  .d-flex.w-100 {
    flex-direction: column !important;
    gap: 10px;
  }
  
  .scout-button,
  .next-button {
    width: 318px !important;
    height: 53px;
  }
}
</style>
